import FirstFold from '@components/ramadan-coding-camp/first-fold'
import Testimonial from '@components/summer-camp/testimonial'
import { NextSeo } from 'next-seo'
import { ramadanCampPageSeo } from '@lib/seo'
import Partners from '@components/landing-page/geo-landing-page/partners'
import Footer from '@components/book-trial-for-uae/footer'
import WhyCodingal from '@components/book-trial-for-uae/why-codingal'
import Benefits from '@components/landing-page/geo-landing-page/benefits'

const RamadanCodingCamp = () => {
  return (
    <>
      <NextSeo {...ramadanCampPageSeo} />
      <FirstFold />
      <Partners />
      <Benefits customSubHeading="Show the world your child can code with certificates in game, app, web development, data science, and many more" />
      <Testimonial isArabCountry pageCta="Try a free lesson" />
      <WhyCodingal />
      <Footer />
    </>
  )
}

export default RamadanCodingCamp
